import { IApiRequest } from "@miplatform/types";
import { useBids } from "@mibuildweb/hooks";

export const useBidsViewModel = () => {
  const { isLoading, refresh, bids, setBids, getBids, deleteBid } = useBids();

  const fetchBids = ({ top, skip }: IApiRequest) => {
    return getBids({
      top,
      skip,
      filters: { not: { builderId: { type: "guid", value: null } } }, // for excluding area templates which have null builderId
    });
  };

  return {
    isLoading,
    refresh,
    bids,
    setBids,
    fetchBids,
    deleteBid,
  };
};
